module.exports = __webpack_public_path__ + "static/media/log-out.c0936271.svg";